module.exports = __webpack_public_path__ + "img/bezier-curve-01.86bbf460.svg";